import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import * as actions from '../actions'

const StatusIcon = ({ type }) => (
	<span className="toast__icon" aria-hidden="true">
		<svg width="12" height="12" viewBox="0 0 16 16">
			{type === 'error' ? (
				<path d="M8 3.5v5.5M8 12.25v.25" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
			) : (
				<path d="M3 8.5 6.5 12 13 4.5" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
			)}
		</svg>
	</span>
)

// White cards in the corner; errors interrupt screen readers, other messages wait politely.
// Nothing renders while there are none
export const Notifications = ({ allIds, byId, dismissNotification }) =>
	allIds.length ? (
	<div className="notification-box-container">
		{allIds.map(id => {
			const { type, message } = byId[id] || {}
			if (!message) return null
			return (
				<div key={id} className={`toast toast--${type}`} role={type === 'error' ? 'alert' : 'status'}>
					<StatusIcon type={type} />
					<div className="toast__message">{message}</div>
					<button
						type="button"
						className="toast__close"
						onClick={() => dismissNotification(id)}
						aria-label="Dismiss"
					>
						<svg width="12" height="12" viewBox="0 0 16 16" aria-hidden="true">
							<path d="M4 4l8 8M12 4l-8 8" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
						</svg>
					</button>
				</div>
			)
		})}
	</div>
	) : null

Notifications.propTypes = {
	allIds: PropTypes.array.isRequired,
	byId: PropTypes.object.isRequired,
	dismissNotification: PropTypes.func.isRequired
}

export default connect(({ notifications: { allIds, byId } }) => ({ allIds, byId }), actions)(
	React.memo(Notifications)
)
